var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        width: "900px",
        height: "80%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "manual" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v(
            "1：" +
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p1")
              )
          ),
        ]),
        _c("p", { staticClass: "title" }, [
          _vm._v(
            "2：" +
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p2")
              )
          ),
        ]),
        _c("div", [
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "3：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p3")
                )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p301")
              ) + " "
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p302")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p303")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p304")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p305")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p306")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p307")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p308")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p309")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p310")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p311")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p312")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p313")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p314")
              )
            ),
          ]),
        ]),
        _c("div", [
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "4：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p4")
                )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p41")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p42")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p43")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p44")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p45")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p46")
              )
            ),
          ]),
        ]),
        _c("div", [
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "5：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p5")
                )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p51")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p52")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p53")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p54")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p55")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p56")
              )
            ),
          ]),
        ]),
        _c("div", [
          _c("p", { staticClass: "title" }, [
            _vm._v(
              "6：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p6")
                )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.1：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p601")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p602")
              )
            ),
          ]),
          _c("p", { staticClass: "formula p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p603")
              )
            ),
          ]),
          _c("p", { staticClass: "formula p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p604")
              )
            ),
          ]),
          _c("p", { staticClass: "formula p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p605")
              )
            ),
          ]),
          _c("p", { staticClass: "formula p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p606")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.2：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p607")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p608")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p609")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p610")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p611")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p612")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p613")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p614")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.3：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p616")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p617")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.4：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p618")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p619")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p620")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p621")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p622")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p623")
              )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.5：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p624")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              _vm._s(
                _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p625")
              )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "i:" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p626")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "ii:" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p627")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "iii：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p628")
                )
            ),
          ]),
          _c("p", [
            _vm._v(
              "6.6：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p629")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "i：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p630")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "ii：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p631")
                )
            ),
          ]),
          _c("p", { staticClass: "p3" }, [
            _vm._v(
              "iii：" +
                _vm._s(
                  _vm.$t("BusinessPurchaseForecast.forecastUserManualData.p632")
                )
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }